<template>
    
    <nav v-if="this.$store.getters.Loaded &&  this.$store.getters.GetBlock.footer" class="uk-navbar-container  uk-margin-top " uk-navbar>
        
        <div class="uk-child-width-expand@s uk-text-center uk-navbar-center uk-margin-top " uk-grid>
            <div calss="">
                <div class="uk-card uk-card-default uk-card-title ">
                    <a class=" " href="https://minobrnauki.gov.ru/" title="МИНИСТЕРСТВО НАУКИ. И ВЫСШЕГО ОБРАЗОВАНИЯ. РОССИЙСКОЙ ФЕДЕРАЦИИ" target="_blank">
                    <img alt="ИТПМ" title="МИНИСТЕРСТВО НАУКИ. И ВЫСШЕГО ОБРАЗОВАНИЯ. РОССИЙСКОЙ ФЕДЕРАЦИИ" src="../assets/img/logo/minobr.svg" width="150" height="150" >
                </a>
                </div>
            </div>
            
            <div v-if="this.$store.getters.Lang=='En'" calss="">
                <div class="uk-card uk-card-default uk-card-title ">
                    <a class=" " href="https://new.ras.ru/academy/ob-akademii/300-let-istorii/" title="РАН" target="_blank">
                    <img alt="ИТПМ" title="РАН" src="../assets/img/logo/ras_ru.svg" width="180" height="180" >
                </a>
                </div>
            </div>
            <div v-else calss="">
                <div class="uk-card uk-card-default uk-card-title ">
                    <a class=" " href="https://new.ras.ru/academy/ob-akademii/300-let-istorii/" title="RAS" target="_blank">
                    <img alt="ИТПМ" title="RAS" src="../assets/img/logo/ras_en.svg" width="180" height="180" >
                </a>
                </div>
            </div> 
            <div>
                <div class="uk-card uk-card-default uk-card-title">
                <a class=" " href="https://sfu-kras.ru/" title="Сибирский федеральный университет" target="_blank">
                    <img alt="SFU" title="Сибирский федеральный университет" src="../assets/img/logo/sfu.png" width="180" height="180" >
                </a>
                </div>
            </div>
                       
            <div>
                <div class="uk-card uk-card-default uk-card-title">
                    <a class=" " href="https://kmc.sfu-kras.ru/" target="_blank" title="Отдел Регионального научно-образовательного математического центра «Красноярский математический центр»">
                    <svg title="Отдел Регионального научно-образовательного математического центра «Красноярский математический центр»" class="-left" width="150" height="150" viewBox="0 0 46 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.69303 14.9089L0.663314 25.6879L15.7201 24.2538L24.6354 13.2979L9.69303 14.9089ZM0.0828683 0.00778031L0.0385006 25.3899L8.20397 12.6004L24.6599 12.6644L0.0828683 0.00778031ZM17.4409 25.9712L45.6359 23.4663L25.566 13.1308L17.4409 25.9712ZM0.037034 26.3254L0 47.0533L16.5212 26.4465L0.037034 26.3254ZM18.2644 28.1987L44.5524 24.4025L27.736 42.8848L1.448 46.681L18.2644 28.1987ZM45.3367 45.3959L30.28 46.8297L21.3646 57.786L36.3073 56.175L45.3367 45.3959ZM45.9619 45.6937L37.796 58.4835L21.3404 58.4192L45.9175 71.0754L45.9619 45.6937ZM45.9633 44.7582L46 24.0306L29.4788 44.6367L45.9633 44.7582ZM28.5595 45.1123L0.364108 47.6175L20.4344 57.9527L28.5595 45.1123Z" fill="#00C88C"></path>
                    </svg>        
                    </a>
                </div>
            </div> 
                    
            
            
            
            <div>
                <div class="uk-card uk-card-default uk-card-title">
                <a class=" " href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/nauka-i-universitety" title="НАУКА И УНИВЕРСИТЕТЫ" target="_blank">
                    <img alt="SFU" title="НАУКА И УНИВЕРСИТЕТЫ" src="../assets/img/logo/min.png" width="200" height="200" >
                </a>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-default uk-card-title">
                    <a class=" " href="https://icm.krasn.ru/" target="_blank" title="ИНСТИТУТ ВЫЧИСЛИТЕЛЬНОГО МОДЕЛИРОВАНИЯ СО РАН">
                        <img alt="ICM" title="ИНСТИТУТ ВЫЧИСЛИТЕЛЬНОГО МОДЕЛИРОВАНИЯ СО РАН" src="../assets/img/logo/icm.png" width="150" height="150" >
                    </a>
                </div>
            </div>    
            <div calss="">
                <div class="uk-card uk-card-default uk-card-title ">
                    <a class=" " href="http://www.itam.nsc.ru/" title="Институт теоретической и прикладной механики им. С. А. Христиановича СО РАН" target="_blank">
                    <img alt="ИТПМ" title="Институт теоретической и прикладной механики им. С. А. Христиановича СО РАН" src="../assets/img/logo/itpm.svg" width="300" height="200" >
                </a>
            </div>
            </div>            
        </div>
    </nav>
</template>




<!--div class="uk-navbar-center uk-margin-top uk-margin-buttom">
    <ul class="uk-navbar-nav">
        <li class="uk-link-heading uk-menu-item">
            <div class=" ">
                <a class=" " href="https://kmc.sfu-kras.ru/">
                    <svg class="-left" width="70" height="70" viewBox="0 0 46 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.69303 14.9089L0.663314 25.6879L15.7201 24.2538L24.6354 13.2979L9.69303 14.9089ZM0.0828683 0.00778031L0.0385006 25.3899L8.20397 12.6004L24.6599 12.6644L0.0828683 0.00778031ZM17.4409 25.9712L45.6359 23.4663L25.566 13.1308L17.4409 25.9712ZM0.037034 26.3254L0 47.0533L16.5212 26.4465L0.037034 26.3254ZM18.2644 28.1987L44.5524 24.4025L27.736 42.8848L1.448 46.681L18.2644 28.1987ZM45.3367 45.3959L30.28 46.8297L21.3646 57.786L36.3073 56.175L45.3367 45.3959ZM45.9619 45.6937L37.796 58.4835L21.3404 58.4192L45.9175 71.0754L45.9619 45.6937ZM45.9633 44.7582L46 24.0306L29.4788 44.6367L45.9633 44.7582ZM28.5595 45.1123L0.364108 47.6175L20.4344 57.9527L28.5595 45.1123Z" fill="#00C88C"></path>
                    </svg>        
                </a>    
            </div>
        </li>
        <li class="uk-link-heading uk-menu-item">
            <div class="">
                <a class=" " href="https://kmc.sfu-kras.ru/">
                    <img alt="ICM" src="../assets/img/logo/icm.png" width="70" height="70" >
                </a>
            </div>
        </li>
        <li class="uk-link-heading uk-menu-item">
            <div class=" ">
                <a class=" " href="https://kmc.sfu-kras.ru/" title="SFU">
                    <img alt="ИТПМ" src="../assets/img/logo/itpm.svg" width="150" height="70" >
                </a>
            </div>
        </li>
        <li class="uk-link-heading uk-menu-item">
            <div class=" " >
                <a class=" " href="https://kmc.sfu-kras.ru/" title="SFU">
                    <img alt="SFU" src="../assets/img/logo/sfu.png" width="80" height="80" >
                </a>
            </div>
        </li>
    </ul>
</div-->